import React, { useContext } from "react";
import AnalyserContext from "./analyserContext";
import { useTranslation } from "react-i18next";
import useTimeline from "../UserTimeline/useTimeline";
import CustomToggleButton from "../Components/CustomToggleButton";

export default function TimeViewSelector() {
  const { timeline } = useTimeline();
  const timePoints =
    timeline?.events
      ?.sort((event1, event2) => event1.time - event2.time)
      .map((event) => event.time) ?? []; // array of timeStamps, extracted from timeline

  const { moodboard, moodboardDispatch } = useContext(AnalyserContext);
  const { t } = useTranslation();
  const handleClick = (view) => moodboardDispatch({
    type: "CHANGE_VIEW",
    payload: { view, timePoints },
  });
  const buttons = [
    { id: "last2weeks", title: t("moodboards.buttons.last2weeks") },
    { id: "last4weeks", title: t("moodboards.buttons.last4weeks") },
    { id: "alltime", title: t("moodboards.buttons.allTime") },
  ]
  
  return <CustomToggleButton title={t("moodboards.settings.range")} buttons={buttons} selected={moodboard.view} handleClick={handleClick} />
}
